import actions from './actions';

const initState = {
    users:    [],
    allPermissions:   [],
    errors:     {},
    loading:    false,
    userInfo: {},
    editView:   false,
    addView:   false,
    showInactive:   false,
    inviteView:   false,
    addModal:   true,
    facilities: [],
    parentId: '',
};

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.FETCH_USERS:
            return {
                ...state,
                loading: true,
                editView: false,
            };
        case actions.FETCH_USERS_SUCCESS:
            return {
                ...state,
                users: action.users,
                loading: false,
                editView: false,
            };
        case actions.FETCH_ALL_PERMISSIONS:
            return {
                ...state,
                loading: true,
            };
        case actions.FETCH_ALL_PERMISSIONS_SUCCESS:
            return {
                ...state,
                allPermissions: action.permissions,
                loading: false,
            };
        case actions.FETCH_USER:
            return {
                ...state,
                loading: true,
                editView: false,
            };
        case actions.FETCH_USER_SUCCESS:
            return {
                ...state,
                userInfo: action.user,
                loading: false,
                editView: false,
            };
        case actions.ADD_USER:
            return {
                ...state,
                editView: action.view,
                userInfo: null,
            };
        case actions.EDIT_USER_VIEW:
            return {
                ...state,
                editView: action.view,
                userInfo: !action.view && state.userInfo ? {} : state.userInfo
            };
        case actions.SAVE_USER:
            return {
                ...state,
                loading: true,
            };
        case actions.SAVE_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                editView: false,
                userInfo: {}
            };
        case actions.SAVE_USER_ERROR:
                return {
                    ...state,
                    loading: false,
                };
        case actions.TOGGLE_INACTIVE:
            return {
                ...state,
                showInactive: state.toggle,
            };
        case actions.CHECK_USER_EMAIL:
            return {
                ...state,
                loading: true,
            };
        case actions.CHECK_USER_EMAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                userInfo: action.user,
                editView: true
            };
        case actions.INACTIVATE_USER:
            return {
                ...state,
                loading: true,
            };
        case actions.INACTIVATE_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                editView: false
            };
        case actions.UPDATE_USER_INFO:
            return {
                ...state,
                userInfo: action.userInfo
            };
        case actions.FETCH_FACILITIES:
            return {
                ...state,
                parentId: action.parentId,
            }
        case actions.FETCH_FACILITIES_SUCCESS:
            return {
                ...state,
                facilities: action.facilities,
            }

        default:
            return state;
    }

}
